import { TaskApiOptions, TaskApiResponseResult } from './types';

export type State = {
  taskList: Array<TaskApiResponseResult>;
  taskListAll: Array<TaskApiResponseResult>;
  totalResultCountTaskList: number;
  totalResultCountTaskListAll: number;
  isLoading: boolean;
  settingsTaskList: TaskApiOptions;
  settingsTaskListAll: TaskApiOptions;
  newTasksCount: number;
  newTasksAllCount: number;
};

const defaultSettings: TaskApiOptions = {
  pageCount: 0,
  pageSize: 0,
  pageStart: 0,
  pageNo: 1,
  sortKey: 'dateDue',
  sortDesc: true,
  viewDone: false,
  viewClaimed: false,
  filters: [],
};

export const state: State = {
  taskList: [],
  taskListAll: [],
  totalResultCountTaskList: 0,
  totalResultCountTaskListAll: 0,
  isLoading: false,
  settingsTaskList: { ...defaultSettings },
  settingsTaskListAll: { ...defaultSettings },
  newTasksCount: 0,
  newTasksAllCount: 0,
};
